module.exports = __webpack_public_path__ + "static/img/6b.96fca5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6b.jpg
// module id = tshg
// module chunks = 0